import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.content.cloneNode(true)
    this.containerTarget.appendChild(content)
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest(".flex")
    if (row) {
      row.remove()
    }
  }
}
